<script setup>
import {defineProps, onMounted, onUnmounted, nextTick, ref, computed} from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useScreen } from 'vue-screen';
import 'swiper/css';

const screen = useScreen();

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  rightDescription: {
    type: String,
    default: ''
  },
  platesTitle: {
    type: String,
    default: ''
  },
  platesType: {
    type: String,
    default: ''
  },
  logo: {
    type: String,
    default: ''
  },
  backgroundImage: {
    type: String,
    default: ''
  },
  plates: {
    type: Object,
    default: () => {}
  }
});

const scrolled = ref(false);
const containerRef = ref(null);

const checkScroll = () => {
  if (containerRef?.value) {
    const rect = containerRef?.value.getBoundingClientRect();
    if (rect.top + rect.height / 2 <= window.innerHeight) {
      scrolled.value = true;
      window.removeEventListener('scroll', checkScroll);
    }
  }
}

const swiperOptions = computed(() => {
  return {
    slidesPerView: props.platesType === 'images' ? 1.3 : 1,
    spaceBetween: 10,
    breakpoints: {
      '768': {
        spaceBetween: 16,
        slidesPerView: props.platesType === 'images' ? 3 : 1,
      }
    },
  }
})

onMounted(() => {
  window.addEventListener('scroll', checkScroll);
  nextTick(() => {
    checkScroll();
  })
})
onUnmounted(() => {
  window.removeEventListener('scroll', checkScroll);
});

</script>

<template>
  <div :class="['features-block', {'_scrolled': scrolled}]" ref="containerRef">
    <img :src="backgroundImage" alt="" class="features-block__bg" loading="lazy">
    <div class="features-block__inner">
      <div class="features-block__title">
        <h2 v-html="title"></h2>
        <img :src="logo" alt="" loading="lazy" />
      </div>
      <div class="features-block__description">
        <p v-html="description"></p>
        <p v-html="rightDescription"></p>
      </div>
      <p class="features-block__items-title">{{ platesTitle }}</p>
      <div :class="['features-block__items', `_${platesType}`]">
        <template v-if="screen.width > 1023">
          <div v-for="(item, index) in plates" :key="index" class="features-block__item" :style="{'transition-delay': `${index * 0.3}s`}">
            <img :src="item.image" alt="" loading="lazy" v-if="platesType === 'images'">
            <span v-else class="_count">{{ index + 1 }}</span>
            <p v-html="item.text"></p>
          </div>
        </template>
        <Swiper
            v-else
            v-bind="swiperOptions"
        >
          <SwiperSlide v-for="(item, index) in plates" :key="index">
            <div class="features-block__item">
              <img :src="item.image" alt="" loading="lazy" v-if="platesType === 'images'">
              <span v-else class="_count">{{ index + 1 }}</span>
              <p v-html="item.text"></p>
            </div>
          </SwiperSlide>
          <template #pagination></template>
        </Swiper>
      </div>
    </div>
  </div>
</template>